import { formatDateForAPI } from "utils/utils";
import CalendarDatePicker from "ui/components/comp-507";
import UserCombobox from "components/directus/combobox/user";

export default function MyTeamTimesheetFilters({
    filters,
    setFilters,
}) {

    return (
        <div className="flex gap-2">
            <UserCombobox
                value={filters?.employee?._eq}
                onChange={(val) => setFilters({ ...filters, employee: val ? { _eq: val } : undefined })}
                filter={{ user: { status: { _eq: "active" } } }}
                className="w-70"
                searchPlaceholder="Search employee..."
                hideLabel={true}
                clearable={true}
            />
            <CalendarDatePicker
                date={{
                    from: filters?.date?._gte,
                    to: filters?.date?._lte,
                }}
                setDate={(range) =>
                    setFilters({
                        ...filters,
                        date: {
                            _gte: range?.from ? formatDateForAPI(range.from) : undefined,
                            _lte: range?.to ? formatDateForAPI(range.to) : undefined,
                        },
                    })
                }
            />
        </div>
    );
}
